import moment from 'moment';
import { call, put, select, takeEvery, takeLeading, fork, cancel, take } from 'redux-saga/effects';
import {
    APPLICATION_FETCH,
    APPLICATION_FETCH_REFRESH,
    APPLICATION_UPDATE_POST_APPROVAL_FORM_DATA,
    SET_APPLICATION,
    UPDATE_APPLICATION_STATUS,
    APPLICATION_LIST_REFRESH,
    UPDATE_APPLICATION_STATUS_WITH_DETAIL,
    APPLICATION_FETCH_WITH_CANCEL,
    APPLICATION_FETCH_COMPLETE,
    CLEAR_UP_REDUX,
} from 'store/key';
import { produce } from 'utility/general';
// import { RETURNED } from 'utility/lookup';
import api from 'api/call';
import { refreshApplicationDetail } from 'store/applicationDetail/reducer';
import { safeSaga } from 'store';
import { APP_FORM_STATUS_NOT_MATCH, UPDATE_APPLICATION_FORM_FAIL } from 'utility/frontendMessage';
import { NA, REJECT_REQUEST_FOR_RETURN, SUSPEND } from 'utility/lookup';

const getInitialState = () => {
    return {};
};

function* updatePostApprovalFormData(action) {
    const { application } = yield select();

    const { formData, irbNo } = action.payload;

    const index = application.draft.findIndex((item, index) => {
        return item.id === irbNo;
    });

    if (index !== -1) {
        application.draft[index].title = formData.studyTitle;
        application.draft[index].referenceNumber = formData.referenceNumber;
        application.draft[index].expired = moment(formData.endDate).format('YYYY-MM-DD HH:mm:ss'); //
        application.draft[index].pi = formData.pi; //
        application.draft[index].piEmail = formData.piEmail;
        application.draft[index].sampleSize = formData.sampleSize;
    }

    yield put({
        type: SET_APPLICATION,
        payload: application,
    });
}

export function* refreshApplicationList(action) {
    const { application } = yield select();
    const { page = 1, pageSize = 10, isDesc = true, sort = 'updateDtm', folder } = application;

    const payload = action?.payload ?? {};

    const { callback, final, onError = () => null } = payload;
    try {
        yield put({
            type: SET_APPLICATION,
            payload: {
                isLoading: true,
            },
        });

        const res = yield call(api.application.getApplication, {
            page,
            pageSize,
            isDesc,
            sort,
            folder,
        });

        const { result } = res.data;
        const { result: data, ...rest } = result;

        /** disabled checkbox when statusId === 0 */
        const rows = data?.map((item) => {
            if (item.statusId === 0) {
                item.disabledItemCheckbox = true;
            }
            return item;
        });

        yield put({
            type: SET_APPLICATION,
            payload: {
                ...rest,
                data: rows,
                sort,
                isDesc,
            },
        });

        yield put({
            type: SET_APPLICATION,
            payload: {
                isLoading: false,
            },
        });

        callback?.();
        final?.();
    } catch (error) {
        yield put({
            type: SET_APPLICATION,
            payload: {
                isLoading: false,
            },
        });
        onError(error);
        final?.();
        console.log('120600 reducer.js error', error);
        throw error;
    }
}

function* updateApplicationStatusWithDetail(action) {
    const {
        id,
        details,
        callback,
        final = () => null,
        onError = () => null,
        updateApplicationDetail = false,
        updateApplicationList = false,
        hasCCOAction = false,
        cluster,
        status,
        expiryDate,
        irbNo,
        irbFlow,
        decisionDate,
        currentStatus,
        approvalExpiryDate,
    } = action.payload;

    // details includes an array of
    // 1. comment
    // 2. uploadTempId : []
    // 3. type // required when status is return
    // 4. value // required when status is return

    // setGlobalLoading(true);

    try {
        // if status is not the following, check the local cache status is sync with server status
        if (status !== SUSPEND && status !== NA && status !== REJECT_REQUEST_FOR_RETURN && currentStatus) {
            const localCacheStatusId = currentStatus;
            const res = yield call(api.application.checkApplicationStatus, id);
            const remoteStatusId = res.data.result;

            if (localCacheStatusId !== remoteStatusId) {
                throw new Error(APP_FORM_STATUS_NOT_MATCH);
            }
        }

        yield call(api.application.updateApplicationStatusWithDetail, {
            id,
            detail: {
                details,
                status,
                expiryDate,
                irbNo,
                irbFlow,
                decisionDate,
                hasCCOAction,
                approvalExpiryDate,
                distributedCluster: cluster,
            },
        });

        if (updateApplicationDetail) {
            yield refreshApplicationDetail({
                payload: { id },
            });
        }

        if (updateApplicationList) {
            yield refreshApplicationList();
        }

        callback?.();
        final();
    } catch (error) {
        if (error.message === APP_FORM_STATUS_NOT_MATCH) {
            onError(error);
        } else {
            onError(new Error(UPDATE_APPLICATION_FORM_FAIL));
        }

        final();
        console.log('164317 reducer.js error', error);
        throw error;
    }
}

function* fetchApplicationWithCancel(action) {
    yield put({
        type: APPLICATION_FETCH_COMPLETE,
        payload: {
            message: 'cancelled',
        },
    });

    const fetchCall = yield fork(fetchApplication, action);
    const result = yield take(APPLICATION_FETCH_COMPLETE);
    if (result?.payload?.message !== 'success') {
        yield cancel(fetchCall);
    }
}

function* fetchApplication(action) {
    try {
        const { page = 1, pageSize = 10, isDesc = true, sort = 'updateDtm', folder } = action.payload;

        yield put({
            type: SET_APPLICATION,
            payload: {
                isLoading: true,
            },
        });

        const res = yield call(api.application.getApplication, {
            page,
            pageSize,
            isDesc,
            sort,
            folder,
        });

        const { result } = res.data;
        const { result: data, ...rest } = result;

        /** disabled checkbox when statusId === 0 */
        const rows =
            data?.map((item) => {
                if (item.statusId === 0) {
                    item.disabledItemCheckbox = true;
                }
                return item;
            }) ?? [];

        yield put({
            type: SET_APPLICATION,
            payload: {
                ...rest,
                data: rows,
                sort,
                isDesc,
                folder,
            },
        });
    } catch (error) {
        console.log('120600 reducer.js error', error);
    }

    yield put({
        type: SET_APPLICATION,
        payload: {
            isLoading: false,
        },
    });

    yield put({
        type: APPLICATION_FETCH_COMPLETE,
        payload: {
            message: 'success',
        },
    });
}

function* updateApplicationStatus(action) {
    const {
        id,
        formStatus,
        comment,
        callback = () => null,
        updateApplicationList = false,
        updateApplicationDetail = false,
        final = () => null,
        onError = () => null,
    } = action.payload;

    try {
        yield call(api.application.updateApplicationDetail, { id, data: { formStatus, comment } });

        if (updateApplicationDetail) {
            yield refreshApplicationDetail({
                payload: { id },
            });
        }

        if (updateApplicationList) {
            yield refreshApplicationList();
        }
        final();
        callback?.();
    } catch (error) {
        onError(error);
        final();
        console.log('164317 reducer.js error', error);
        throw error;
    }
}

const reducer = (state = getInitialState(), action) => {
    switch (action.type) {
        case SET_APPLICATION:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        case CLEAR_UP_REDUX:
            return getInitialState();
        default:
            return state;
    }
};

export default reducer;

export function* watchApplication() {
    yield takeEvery(APPLICATION_UPDATE_POST_APPROVAL_FORM_DATA, safeSaga(updatePostApprovalFormData));
    yield takeEvery(APPLICATION_FETCH, safeSaga(fetchApplication));
    yield takeLeading(APPLICATION_LIST_REFRESH, safeSaga(refreshApplicationList));
    yield takeLeading(APPLICATION_FETCH_REFRESH, safeSaga(fetchApplication));
    yield takeEvery(UPDATE_APPLICATION_STATUS, safeSaga(updateApplicationStatus));
    // yield takeEvery(RETURN_APPLICATION_FORM, safeSaga(returnApplication));
    yield takeEvery(UPDATE_APPLICATION_STATUS_WITH_DETAIL, safeSaga(updateApplicationStatusWithDetail));
    yield takeEvery(APPLICATION_FETCH_WITH_CANCEL, safeSaga(fetchApplicationWithCancel));
}
